import React from 'react'
import FormInput from '../../../../library/form/components/FormInput';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormHHMMInput from '../../../../library/form/components/FormHHMMInput';

const BomProcessAddRow = (props) => {
const { formObject, rowKey } = props;

        return (
            <ul className="uiDPEditLine">
                <li className="uiColumnCenter uiColumn50">
                    <FormInput formObject={formObject} rowKey={rowKey} style={{width:"50px"}}
                        action={{ InputType: "input", paramName: "seqNo", actionId: "refresh", 
                            actionParam: {editSource:"seqNo"} }}
                        />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormInput formObject={formObject} rowKey={rowKey} style={{width:"140px"}}
                        action={{ 
                            InputType: "ac", paramName: "pName", acMethod: "ProcessName", 
                            acDepCtrl: { dtId: "%dataList.valLDT" },
                            actionId: "refresh", actionParam: {editSource:"pName"}
                        }} 
                    ></FormInput>
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormHHMMInput className="uiCenterAlignText" formObject={formObject} rowKey={rowKey} style={{width:"90px"}}
                        action={{ InputType: "input", paramName: "estQty1", actionId: "refresh", 
                        actionParam: {editSource:"estQty1"} }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormInput className="uiRightAlignText" formObject={formObject} rowKey={rowKey} style={{width:"90px"}}
                        action={{ InputType: "input", paramName: "processCost", actionId: "refresh", 
                        actionParam: {editSource:"processCost"} }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn90">
                    <FormInput className="uiRightAlignText" formObject={formObject} rowKey={rowKey} style={{width:"90px"}}
                        action={{ InputType: "input", paramName: "ohCost", actionId: "refresh", 
                        actionParam: {editSource:"ohCost"} }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn200">
                    <FormInput formObject={formObject} rowKey={rowKey} style={{width:"180px"}}
                        action={{ InputType: "input", paramName: "comment", actionId: "refresh", 
                        actionParam: {editSource:"comment"} }}
                    />
                </li>
                <li className="uiColumnCenter uiColumn50 uiActionBlock">
                    <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "del",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>
                </li>
            </ul>
        )
}

export default BomProcessAddRow